<mat-card class="py-20" style="padding: 20px 5px;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100">
            <div>
                <mat-card-title>Record Medication Dispense</mat-card-title>
            </div>
        </div>
    </mat-card-header>
    <mat-card-content>
        <!-- {{data.medicationReference | json}} -->
        <!-- {{medicationReference | json}} -->
        @if(!groupId){
        <!-- {{MedicationReferenceArray.value | json}}
        <br>
        <br> -->
        <!-- {{combinedResource | json}}
        <br>
        <br> -->
        <!--{{medicationReference[0]}} -->
        <!-- {{dispensabeUnits | json}} -->



        <div class="py-15">
            @if(this.medicationCodeableConcept || this.medicationReference){
            <span class="subtitle-text-color-2" style="font-size: 1rem">Recording dispense for medication: </span>
            <span>
                @if(this.medicationCodeableConcept && this.medicationCodeableConcept.length > 0
                && this.medicationCodeableConcept[0] !== null
                ){

                <strong>{{ this.medicationCodeableConcept[0] | codeableConcept2 | na | titlecase }}</strong>
                }@else if(this.medicationReference && this.medicationReference[0]){
                <!-- {{medicationReference[0]?.reference}} -->
                <strong><span [appReferenceDisplay]="medicationReference[0]?.reference"
                        InstantfetchAndRepace="true"></span></strong>
                }
            </span>
            @if(medicationRequestId[0]){
            @if(this.medicationReference && this.medicationReference[0]){
            <button (click)="openSubstitutionForm(medicationRequestId[0] );" style="border: 1px solid var(--mat-sys-outline); padding: 1px;
            padding-right: 12px; font: inherit; cursor: pointer;
            background-color: var(--mat-sys-surface-variant);
                border-radius: 4px; display: inline-flex; vertical-align: middle; justify-content: center; align-items: center;
                " color="tertiary" class="ms-10">
                <mat-icon class="me-8">swap_horiz</mat-icon> Substitute Medication
            </button>}}
            <div class="gap py-7">
                <!-- {{this.substitutionFormArray.value | json}} -->
                <!-- {{medicationRequestId+'jju'}} -->
                @if(medicationRequestId[0]){
                @if(newMedicationCodeableConcept?.[medicationRequestId[0]] ||
                newMedicationReference?.[medicationRequestId[0]]){
                <span class="subtitle-text-color-2" style="font-size: 1rem">New
                    <span><strong>Substituted</strong></span> medication to dispense: </span>
                <!-- {{ newMedicationCodeableConcept | json}} -->
                <!-- lll{{newMedicationReference[medicationRequestId[0]] | json}} -->
                <span>
                    @if(medicationRequestId && newMedicationCodeableConcept ?.[medicationRequestId[0]]){
                    <strong>{{ newMedicationCodeableConcept[medicationRequestId[0] || ''] | codeableConcept2 | na |
                        titlecase }}</strong>
                    }@else if(newMedicationReference?.[medicationRequestId[0]]){
                    <strong><span [appReferenceDisplay]="newMedicationReference[medicationRequestId[0]]?.reference"
                            InstantfetchAndRepace="true"></span></strong>

                    }
                </span>

                <button (click)="reverseSubstitution(medicationRequestId[0] );" style="border: 1px solid var(--mat-sys-outline); padding: 1px;
            padding-right: 12px; font: inherit; cursor: pointer;
            background-color: var(--mat-sys-surface-variant);
                border-radius: 4px; display: inline-flex; vertical-align: middle; justify-content: center; align-items: center;
                " color="tertiary" class="ms-10">
                    <mat-icon class="me-8">swap_horiz</mat-icon> Reverse Substitution
                </button>

                }
                }
            </div>

            }@else{
            <span class="subtitle-text-color-2">No medication specified for this dispense.</span>
            }
        </div>
        <div class="p-15">
            @if(!medicationRequestId[0] || (medicationRequestId[0] && !medicationReference[0] &&
            !newMedicationReference?.[medicationRequestId[0]!])){
            <span class="py-15" style="text-align: center;">Please select a medication that matches the requested
                drug</span>

            @if(medicationRefenceFormField[0]){
            <app-dynamic-forms-v2 [formFields]="medicationRefenceFormField[0]" [formMetaData]="{formName: '', formDescription: '', 
                    showSubmitButton: false
                }" #mrF>

            </app-dynamic-forms-v2>
            <!-- {{medicationReferenceFallBackForm.value | json}} -->
            }
            }

        </div>
        <!-- {{this.MedicationReferenceArray.value | json}} -->
        <app-dynamic-forms-v2 #formComp [formMetaData]="{
                formName: '', formDescription: '', showSubmitButton: false  
        }" [formFields]="remainingDispenseFormFields[0]" #rf></app-dynamic-forms-v2>
        }@else{
        <div class="py-15">
            To be Implemented later. For now, dispense medications individually. You'll find the button to do so in the
            actions column of the medication requests list.
            <!-- column of the medication requests list. -->
        </div>
        }

        @if(medRequestDosageJson?.[0]){
        <button type="button" mat-fab color="primary" matTooltip="View dosage instructions from MedicationRequest"
            (click)="openMedicationRequestDosageDialog(0)" style="
                position: absolute;
                left: 18px;
                bottom: 50%;
                z-index: 1000;
            ">
            <mat-icon>receipt_long</mat-icon>
        </button>
        }

        @if(showPaymentNotice){
        <div style="
              border: 1px solid var(--mat-sys-outline-variant);
              background: var(--mat-sys-surface-container-low);
              color: var(--mat-sys-on-surface);
              border-radius: 12px;
              padding: 12px 14px;
              margin: 12px 0 16px;
              box-shadow: var(--mat-sys-level-1);
              display: flex;
              gap: 10px;
              align-items: flex-start;
            ">
            <mat-icon style="color: var(--mat-sys-primary); margin-top: 2px;">info</mat-icon>

            <div style="min-width: 0;">
                <div style="font-weight: 600; margin-bottom: 4px;">
                    Payment required to complete dispense
                </div>
                <div style="color: var(--mat-sys-on-surface-variant); line-height: 1.35;">
                    This entry will record the <strong>quantity</strong> and the <strong>actual medication</strong>
                    being dispensed,
                    so an invoice can be generated. The dispense will be marked as <strong>completed</strong> after
                    payment is confirmed.
                </div>
            </div>
        </div>
        }
    </mat-card-content>
    <mat-card-actions align="end">
        <button mat-flat-button color="primary" (click)="submitCombinedDispenseBundle()">Submit Dispense</button>
        <button mat-button mat-dialog-close>Close</button>
    </mat-card-actions>
    <!-- {{medicationRequestId | json}}
    {{combinedResource | json}} -->
</mat-card>